/**
 * Used this component to added links or info into top right header
 * Mobile version: under social links
 */

import React from 'react';

const HeaderTopRightMore = () => {
  return <></>;
};

export default HeaderTopRightMore;
